<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Equivalencias" key="1">
          <g-master :name="master.endpoint"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Descripición')">
                    <a-input
                      v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Valores de equivalencia" key="1">
        <equivalency-values v-if="idEquivalency" :id_equivalency="idEquivalency"/>
        <span v-else>Seleccione una equivalencia para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'equivalency',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripición', dataIndex: 'description', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'description'}
          ]
        }
      }
    },
    computed: {
      idEquivalency () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Equivalency/Equivalency.vue